module.exports = __webpack_public_path__ + "img/done-image.1e0cc572.png";